var rest = require('diy/maintenanceMode/rest');
var globalEvents = require('diy/util/globalEvents');
var features = require('diy/util/features');

var MaintenanceMode;

MaintenanceMode = Klazz.extend({
    /**
     * @type boolean true is maintenance is on (site is offline)
     */
    state: null,
    /**
     * @type boolean true if site is still in initial state (not published)
     */
    firstPublish: null,
    /**
     * @type boolean
     */
    loadingInProgress: null,

    /**
     * @param {Boolean} state
     * @param {Boolean} neverPublished
     */
    initialize: function(state, neverPublished) {
        this.firstPublish = neverPublished;
        this.loadingInProgress = false;
        this.state = state;
    },

    isFirstPublish: function() {
        return this.firstPublish;
    },

    //private
    setLoadingState: function(state) {
        this.loadingInProgress = !!state;
        globalEvents.trigger('diy-maintenance-loading-state-changed', [state]);
    },

    getLoadingState: function() {
        return this.loadingInProgress;
    },

    /**
     * @returns {Q.promise}
     */
    toggleState: function() {
        if (this.state) {
            jQuery(document.body).trigger('PublishWebsiteTried.BSA');
        }
        this.setLoadingState(true);

        return rest
            .toggleState()
            .then(function(state) {
                this.state = state;
                if (!state) {
                    jQuery(document.body).trigger('PublishWebsiteDone.BSA');
                }
                if (this.firstPublish) {
                    this.firstPublish = false;
                    globalEvents.trigger('diy-maintenance-mode-publish');
                }
                globalEvents.trigger('diy-maintenance-mode-changed', [this.state]);
                this.track(this.state);

                return this.state;
            }.bind(this))
            .fin(function() {
                this.setLoadingState(false);
            }.bind(this));
    },

    getState: function() {
        return this.state;
    },

    track: function(state) {
        globalEvents.trigger( 'diy-editor-generic-linkInteraction', {
            'actionName': !!state ? 'enableContructionPage' : 'disableConstructionPage'
        });
    }
});

module.exports = MaintenanceMode;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/maintenanceMode/MaintenanceModeModel.js
 ** module id = 669
 ** module chunks = 0
 **/